import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTipJarDuotone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M22.75 9.625v12.25a3.5 3.5 0 0 1-3.5 3.5H8.75a3.5 3.5 0 0 1-3.5-3.5V9.625a3.5 3.5 0 0 1 3.5-3.5h10.5a3.5 3.5 0 0 1 3.5 3.5Z"
      opacity={0.2}
    />
    <path d="M20.125 5.339V3.5a1.75 1.75 0 0 0-1.75-1.75h-8.75a1.75 1.75 0 0 0-1.75 1.75v1.839a4.38 4.38 0 0 0-3.5 4.286v12.25A4.375 4.375 0 0 0 8.75 26.25h10.5a4.375 4.375 0 0 0 4.375-4.375V9.625a4.38 4.38 0 0 0-3.5-4.286Zm-1.75-.089h-1.75V3.5h1.75v1.75Zm-5.25 0V3.5h1.75v1.75h-1.75Zm-1.75-1.75v1.75h-1.75V3.5h1.75Zm10.5 18.375A2.625 2.625 0 0 1 19.25 24.5H8.75a2.625 2.625 0 0 1-2.625-2.625V9.625A2.625 2.625 0 0 1 8.75 7h10.5a2.625 2.625 0 0 1 2.625 2.625v12.25ZM17.5 17.5a2.625 2.625 0 0 1-2.625 2.625V21a.875.875 0 1 1-1.75 0v-.875h-.875a.875.875 0 1 1 0-1.75h2.625a.875.875 0 1 0 0-1.75h-1.75a2.625 2.625 0 0 1 0-5.25V10.5a.875.875 0 0 1 1.75 0v.875h.875a.875.875 0 1 1 0 1.75h-2.625a.875.875 0 1 0 0 1.75h1.75A2.625 2.625 0 0 1 17.5 17.5Z" />
  </svg>
);
export default SvgTipJarDuotone;
